module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks-Academy_Poster-560a77ebd9c99627ee07173a9f2885d9.jpg";